import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMyVouchers } from "../../services/api";

export const fetchMyVouchers = createAsyncThunk("myVouchers/fetch", async ({ page = 1 } = {}, { rejectWithValue }) => {
    try {
        const res = await getMyVouchers(page);
        if (res?.status === false) return rejectWithValue(res?.message || "Unable to load your vouchers.");
        return { items: res?.data || [], meta: res?.meta || {} };
    } catch (err) {
        return rejectWithValue(err?.message || "Unable to load your vouchers.");
    }
});

const initialState = {
    items: [],
    page: 0,
    lastPage: 1,
    total: 0,
    loading: false,     // first page
    loadingMore: false, // next pages
    loaded: false,
    error: null,
};

const myVouchersSlice = createSlice({
    name: "myVouchers",
    initialState,
    reducers: {
        resetMyVouchers: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMyVouchers.pending, (state, action) => {
                if ((action.meta.arg?.page || 1) > 1) state.loadingMore = true;
                else state.loading = true;
                state.error = null;
            })
            .addCase(fetchMyVouchers.fulfilled, (state, action) => {
                const page = action.meta.arg?.page || 1;
                const { items, meta } = action.payload;
                if (page === 1) {
                    state.items = items;
                } else {
                    const seen = new Set(state.items.map((i) => i.id));
                    state.items = [...state.items, ...items.filter((i) => !seen.has(i.id))];
                }
                state.page = meta.current_page || page;
                state.lastPage = meta.last_page || 1;
                state.total = meta.total ?? state.items.length;
                state.loading = false;
                state.loadingMore = false;
                state.loaded = true;
            })
            .addCase(fetchMyVouchers.rejected, (state, action) => {
                state.loading = false;
                state.loadingMore = false;
                state.error = action.payload || action.error?.message || "Unable to load your vouchers.";
            });
    },
});

export const { resetMyVouchers } = myVouchersSlice.actions;
export default myVouchersSlice.reducer;